import { Message } from '~/components/component-library/Message'
import { useShowMultiSigSwapMessage } from '~/components/forms/swap/hooks/useShowMultiSigSwapMessage'

export const MultiSignSwapMessage = ({
  smartAccountId,
}: {
  smartAccountId?: string
}) => {
  const showMultiSigSwapMessage = useShowMultiSigSwapMessage(smartAccountId)

  if (!showMultiSigSwapMessage) {
    return null
  }

  return (
    <Message title="Have your signers ready" variant="info">
      Swaps need to be executed promptly to guarantee success
    </Message>
  )
}
